import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/DeleteForever';
import Swal from 'sweetalert2';
import "./listado.scss";
import { useNavigate } from 'react-router-dom';
import { collection, deleteDoc, doc, getDoc, getDocs, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { db } from '../../firebase-config';
import * as xlsx from 'xlsx'

// Modal
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ArticleIcon from '@mui/icons-material/Article';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function DataTable() {

  const Navigate = useNavigate();
  const [eventName, setEventName] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [eventDesc, setEventDesc] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [deadLineToReserve, setDeadLineToReserve] = useState("");
  const [Visitors, setVisitors] = useState([]);

  // Constantes para update
  const [nameUpdated, setNameUpdated] = useState("");
  const [organizerUpdated, setOrganizerUpdated] = useState("");
  const [descUpdated, setDescUpdated] = useState("");
  const [dateUpdated, setDateUpdated] = useState("");
  const [startUpdated, setStartUpdated] = useState("");
  const [endUpdated, setEndUpdated] = useState("");
  const [deadLineUpdated, setDeadLineUpdated] = useState("");

  const qId = window.location.pathname.split("/")[3];

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dataExcel = Visitors.map((u) => ({
    Apellido: u.data.lastName,
    Nombre: u.data.name,
    Carta: u.data.card,
    Menu: u.data.type
  }));
  
  //#region Functions
  useEffect(() => {
    const getEventById = async () => {

      try {

        // Get event by id
        const eventQuery = doc(db, "events", qId);
        const eventData = await getDoc(eventQuery);

        // Seteamos las contantes a mostrar
        setEventName(eventData.data().name);
        setEventDesc(eventData.data().description);
        setEventDate(eventData.data().eventDate);
        setStartTime(eventData.data().startTime)
        setEndTime(eventData.data().endTime);
        setOrganizerName(eventData.data().organizerName);
        setDeadLineToReserve(eventData.data().deadLineToReserve);

        // Seteamos las contantes que no se muestran pero sirven para el update
        setNameUpdated(eventData.data().name);
        setDescUpdated(eventData.data().description);
        setDateUpdated(eventData.data().eventDate);
        setStartUpdated(eventData.data().startTime)
        setEndUpdated(eventData.data().endTime);
        setOrganizerUpdated(eventData.data().organizerName);
        setDeadLineUpdated(eventData.data().deadLineToReserve);


        // Get visitors by Event Id
        const visitorsQuery = query(collection(db, "visitors"),where("data.eventId", "==", qId));
        
        const visitorsData = await getDocs(visitorsQuery);

        let visitorList = [];
        visitorsData.docs.forEach((doc) => {
          visitorList.push({ id: doc.id, ...doc.data() });
        });
        setVisitors(visitorList);
    
      } catch (error) {
        console.log(error)
      }


    }
    getEventById();
  }, [qId])


  const descargar=()=>{
    const workSheet = xlsx.utils.json_to_sheet(dataExcel)
    const workBook = xlsx.utils.book_new()
    xlsx.utils.book_append_sheet(workBook, workSheet, `Invitados`)

let buf = xlsx.write(workBook,{bookType:"xlsx", type:"buffer"})

xlsx.write(workBook,{bookType:"xlsx",type:"binary"})

xlsx.writeFile(workBook,`LISTADO ${eventName.toUpperCase().replace(/-/g, ' ')}.xlsx`)

  }


  const handleDelete = async (id) => {

    try {
    Swal.fire({
        title: '¿Estas seguro?',
      icon: 'warning',
      showCancelButton: true,
        confirmButtonColor: '#a68dff',
        cancelButtonColor: '#252525',
      confirmButtonText: 'Eliminar'
      }).then((result) => {
        if (result.isConfirmed) {
           deleteDoc(doc(db, "visitors", id))
          setVisitors(Visitors.filter((item) => item.id !== id));

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
          icon: 'success',
            title: 'Persona eliminada!'
          })
          
        }
      })
     
    } catch (err) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
          showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
        })
      
      Toast.fire({
        icon: 'warning',
        title: 'Hubo un error al eliminar!'
      })
      }
      }
    
    
  const handleDeleteEvent = (e) => {
    e.preventDefault();

    
    try {
      Swal.fire({
          title: '¿Estas seguro?',
      text: "Se va a eliminar el evento seleccionado",
        icon: 'warning',
        showCancelButton: true,
          confirmButtonColor: '#a68dff',
          cancelButtonColor: '#252525',
        confirmButtonText: 'Eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
             deleteDoc(doc(db, "events", qId))
  
            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })
  
            Toast.fire({
            icon: 'success',
              title: 'Evento eliminado!'
            })
            setTimeout(() => {
              Navigate("/admin");
          }, 1600);
          }
        })
       
      } catch (err) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
            showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
          })
        
        Toast.fire({
          icon: 'warning',
          title: 'Hubo un error al eliminar!'
        })
        }
   
  }

  const handleUpdate = async (e) => {
    handleClose();
    e.preventDefault();

    const eventQuery = doc(db, "events", qId);
    const nameToUpdate =  nameUpdated.replace(/ /g, '-').replace(/ñ/g, 'n').toLowerCase();


    try {
      Swal.fire({
          title: '¿Estas seguro?',
      text: "Se va a actualizar el evento",
        icon: 'warning',
        showCancelButton: true,
          confirmButtonColor: '#a68dff',
          cancelButtonColor: '#252525',
        confirmButtonText: 'Actualizar'
        }).then((result) => {
          if (result.isConfirmed) {
            setDoc(eventQuery, {
              name: nameToUpdate,
              description: descUpdated,
              eventDate: dateUpdated,
              organizerName: organizerUpdated,
              startTime: startUpdated,
              endTime: endUpdated,
              deadLineToReserve: deadLineUpdated,
              timeStamp: serverTimestamp()
            });
  
            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })
  
            Toast.fire({
            icon: 'success',
              title: 'Evento actualizado 👍'
            })
            setTimeout(() => {
              window.location.reload();
          }, 1600);
          }
        })
       
      } catch (err) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
            showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
          })
        
        Toast.fire({
          icon: 'warning',
          title: 'Hubo un error al actualizar!'
        })
        }
     
  }
      

  //#endregion

  //#region Filas y columnas
  const rows = Visitors.map((u) => ({
    id: u.id,
    name: u.data.name,
    lastName: u.data.lastName,
    card: u.data.card,
    type: u.data.type
  }));

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'lastName', headerName: 'Apellido', width: 110 },
    { field: 'name', headerName: 'Nombre', width: 110 },
    { field: 'card', headerName: 'Tarjeta', width: 110 },
    { field: 'type', headerName: 'Tipo', width: 110 }
  ];

  const actionColumn = [{
    field: "Accion", headername: "delete", renderCell: (params) => {
      return (
        <div className='cell'>
          <button className='deletebutton' onClick={() => handleDelete(params.row.id)}>Borrar</button>
        </div>
      );
    },
  },
  ];

  //#endregion
  return (
    <div style={{ height: 600, width: '100%', }}>
      <button className='edit' type='button' onClick={handleOpen}><Edit className="icon"></Edit></button>
      <button className='trash' onClick={(e) => handleDeleteEvent(e)}><Delete className="icon"></Delete></button>
      <button className='excel' type='button' onClick={descargar}><ArticleIcon className="icon2"></ArticleIcon></button>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Nombre: {eventName.toUpperCase().replace(/-/g, ' ')}</span>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Descripcion: {eventDesc}</span>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Organizador: {organizerName}</span>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Fecha: {eventDate.slice(0, 10)}</span>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Hora inicio / fin: {startTime.slice(0, 5).concat(" - " + endTime.slice(0, 5))}</span>
      <span style={{ marginLeft: '25px', fontWeight: '600', marginBottom: '10px' }}>Fecha límite para reserva: {deadLineToReserve.slice(0, 10)}</span>
      
      <span className='listado'>Listado de Invitados</span> 

      <DataGrid className="font"
      rows={rows}
      columns={columns.concat(actionColumn)}
      pageSize={100}
      rowsPerPageOptions={[rows]}
      
    />


 <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Actualizar evento
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Nombre </label> <br/>
            <input type="text" defaultValue={eventName.replace(/-/g, ' ')} style={{width:'100%'}} onChange={(e)=> setNameUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Descripcion </label> <br/>
            <textarea rows={1} cols={30} type="text" defaultValue={eventDesc} style={{width:'100%'}} onChange={(e)=> setDescUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Organizador </label> <br/>
            <input type="text" defaultValue={organizerName} style={{width:'100%'}} onChange={(e)=> setOrganizerUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Fecha </label> <br/>
            <input type="date" defaultValue={eventDate} style={{width:'100%'}} onChange={(e)=> setDateUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Hora inicio </label> <br/>
            <input type="time" defaultValue={startTime} style={{width:'100%'}} onChange={(e)=> setStartUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Hora fin </label> <br/>
            <input type="time" defaultValue={endTime} style={{width:'100%'}} onChange={(e)=> setEndUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <label>Fecha limite para reserva </label> <br/>
            <input type="date" defaultValue={deadLineToReserve} style={{width:'100%'}} onChange={(e)=> setDeadLineUpdated(e.target.value)}/>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button onClick={(e) => handleUpdate(e)}>Guardar</Button>
          </Typography>
        </Box>
      </Modal>
    </div>

  );
  }
